"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = EmployeeListItem;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const Helper_1 = require("../Helper");
const react_native_paper_1 = require("react-native-paper");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        leaveLabel: {
            backgroundColor: `${THEME.Amber}AD`,
            borderRadius: 2,
            marginVertical: 4,
            paddingHorizontal: 4,
            paddingVertical: 2,
            alignSelf: 'flex-start'
        },
        leaveLabelText: {
            color: THEME.Text,
            fontSize: (size != 'sm' ? 12 : 10),
            fontWeight: '500'
        },
        activeLabel: {
            backgroundColor: THEME.Secondary,
            borderRadius: 2,
            marginVertical: 4,
            paddingHorizontal: 4,
            paddingVertical: 2,
            alignSelf: 'flex-start'
        },
        activeLabelText: {
            color: THEME.White,
            fontSize: (size != 'sm' ? 12 : 10),
            fontWeight: '500'
        },
        terminatedLabel: {
            backgroundColor: THEME.NeutralGray,
            borderRadius: 2,
            marginVertical: 4,
            paddingHorizontal: 4,
            paddingVertical: 2,
            alignSelf: 'flex-start'
        },
        terminatedLabelText: {
            color: THEME.Text,
            fontSize: (size != 'sm' ? 12 : 10),
            fontWeight: '500'
        }
    });
};
;
function EmployeeListItem(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const eeStatus = props.employee.statusClass.toUpperCase();
    const [startDate, setStartDate] = react_1.default.useState('—');
    const [endDate, setEndDate] = react_1.default.useState('—');
    const [isTakeOn, setIsTakeOn] = react_1.default.useState(false);
    const displayName = `${props.employee.firstName} ${props.employee.middleInitial} ${props.employee.lastName}`.replace(/ +(?= )/g, '');
    react_1.default.useEffect(() => {
        if (props.employee?.hireDate == null || props.employee?.statusDate == null) {
            setIsTakeOn(true);
            return;
        }
        setStartDate(formatDate(props.employee.hireDate));
        switch (eeStatus) {
            case 'A':
                setEndDate('Present');
                break;
            default:
                setEndDate(formatDate(props.employee.statusDate));
                break;
        }
    }, []);
    const formatDate = (dateString) => {
        let [m, d, y] = dateString.split('/');
        const showYear = new Date(y, m - 1, d).getFullYear() != new Date().getFullYear() || true;
        return new Date(y, m - 1, d).toLocaleDateString(Helper_1.Helper.deviceLanguage(), { month: 'short', ...showYear ? { year: 'numeric' } : null, day: 'numeric', timeZone: 'UTC' });
    };
    const title = ((0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 16 : 14, fontWeight: '500', includeFontPadding: true }, children: displayName }));
    const description = ((0, jsx_runtime_1.jsxs)(react_native_1.View, { accessible: false, children: [isTakeOn ||
                (0, jsx_runtime_1.jsxs)(react_native_1.Text, { style: { color: THEME.TextLight, fontSize: size != 'sm' ? 14 : 12 }, children: [startDate, " \u2014 ", endDate] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { accessible: false, style: { alignItems: 'flex-start', justifyContent: 'center' }, children: [eeStatus == 'A' &&
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.activeLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.activeLabelText, children: t('employees:labels.active').toUpperCase() }) }), eeStatus == 'L' &&
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.leaveLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.leaveLabelText, children: t('employees:labels.leave').toUpperCase() }) }), eeStatus == 'T' &&
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.terminatedLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.terminatedLabelText, children: t('employees:labels.terminated').toUpperCase() }) })] })] }));
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flexGrow: 1 }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.List.Item, { accessible: true, "aria-label": displayName + ': ' + startDate + t('common:hints.to') + endDate + ': ' + (eeStatus == 'A' ? t('employees:labels.active') : eeStatus == 'L' ? t('employees:labels.leave') : t('employees:labels.terminated')), title: title, description: description, right: () => ((0, jsx_runtime_1.jsx)(react_native_1.View, { accessible: false, pointerEvents: 'auto', style: { alignSelf: 'center' }, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.ChevronRight, size: 16, color: THEME.Text, style: { marginHorizontal: 8 } }) })), onPress: () => props.onPress(), style: { pointerEvents: 'box-none' }, pointerEvents: 'box-none', theme: { colors: { primary: THEME.Text } } }) }));
}
